import { createStore } from 'vuex'

import { questions } from '@/textConfig'

type SwipeState = 'none' | 'left' | 'right';
type Screen = 'welcome' | 'card' | 'finalform' | 'clap';

export default createStore({
  state: {
    answers: [] as boolean[],
    index: 0,
    questions,
    swipeState: 'none' as SwipeState,
    screen: 'welcome' as Screen,
  },
  getters: {
    question: (state) => state.questions[state.index],
    score: (state) => state.answers.filter((a) => a).length,
    isAllAnswered: (state) => state.answers.length === state.questions.length,
    screen: (state) => state.screen,
  },
  mutations: {
    answer(state, answer: boolean) {
      state.answers.push(answer)
    },
    nextQuestion(state) {
      state.index++
    },
    setSwipeState(state, newSwipeState: SwipeState) {
      state.swipeState = newSwipeState
    },
    start(state) {
      state.screen = 'card';
      return
    },
    finish(state) {
      state.screen = 'finalform';
      return
    },
    submit(state) {
      state.screen = 'clap';
      return
    },
    clickLeft() {
      return
    },
    clickRight() {
      return
    },
  },
  actions: {
    confirm(store) {
      const { state } = store
      if (state.index === state.questions.length - 1) {
        store.commit('finish')
      } else {
        store.commit('nextQuestion')
      }
    },
  },
  modules: {},
})
